import { lazy } from "react"; //insures components are loaded correctly as actual React components rather than Promises.

const routes =[
    {
        path: "/",
        name: "Employee Directory",
        component: lazy(() => import("./employeeDirectory/EmployeeDirectory"))
      },
      {
        path: "/login",
        name: "Login",
        component: lazy(() => import("./LoginComponent"))
      }
];

export default routes;
